import type { Product } from "../lib/api";

type ProductGridProps = {
  products: Product[];
  onOpen: (slug: string) => void;
};

export function ProductGrid({ products, onOpen }: ProductGridProps) {
  return (
    <section className="product-grid" aria-label="Товары">
      {products.map((product) => (
        <button className="product-tile" key={product.id} onClick={() => onOpen(product.slug)}>
          <img
            src={product.media[0]?.url ?? "/placeholders/product.svg"}
            alt={product.media[0]?.altText ?? product.title}
            onError={(event) => {
              event.currentTarget.src = "/placeholders/product.svg";
            }}
          />
          <span className="tile-meta">
            <strong>{product.title}</strong>
          </span>
        </button>
      ))}
    </section>
  );
}
